import { Grid } from '@mui/material'
import GlobalExecutionTable from './Table'
import GlobalReportsSearchesModal from './SearchesModal'
import React from 'react'
import { tabSelected } from '../@signals'
import { GLOBAL_EXECUTION_TABS } from '../@constants'


export default function GlobalExecutionReportsBlock() {
    if (tabSelected.value === GLOBAL_EXECUTION_TABS.SCRAPERS || tabSelected.value === GLOBAL_EXECUTION_TABS.BATCHES) return null

    return <>
        <Grid item xs={12}>
            <GlobalExecutionTable/>
        </Grid>
        <Grid item>
            <GlobalReportsSearchesModal/>
        </Grid>
    </>
}